import { render } from "./MainPage.vue?vue&type=template&id=2f25f6ba"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"
script.render = render

export default script